import {BaseResponse} from './internal/baseresponse';
import {NoticeList} from './internal/list/noticelist';


export class NoticeListResult extends BaseResponse {
  data: NoticeList;
}



// WEBPACK FOOTER //
// ./src/app/response/noticelistresult.ts